import { InventoryModal } from "./InventoryModal";
import { SupplierModal } from "./SupplierModal";
import { SafetyModal } from "./SafetyModal";
import type { SupplyModalKind } from "./RowSupplyIcons";

export type SupplyModalState = { kind: SupplyModalKind; id: string } | null;

type SupplyModalHostProps = {
  state: SupplyModalState;
  onClose: () => void;
};

export function SupplyModalHost({ state, onClose }: SupplyModalHostProps) {
  if (!state) return null;
  if (state.kind === "inventory")
    return <InventoryModal compoundId={state.id} onClose={onClose} />;
  if (state.kind === "supplier")
    return <SupplierModal compoundId={state.id} onClose={onClose} />;
  return <SafetyModal compoundId={state.id} onClose={onClose} />;
}
